module.exports = __webpack_public_path__ + "static/img/news-20240229.8b69ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20240229.png
// module id = st99
// module chunks = 0